import { render } from "./GameModal.vue?vue&type=template&id=98192f4a&scoped=true"
import script from "./GameModal.vue?vue&type=script&lang=js"
export * from "./GameModal.vue?vue&type=script&lang=js"

import "../../../assets/css/landing.css?vue&type=style&index=0&id=98192f4a&scoped=true&lang=css"
import "./GameModal.vue?vue&type=style&index=1&id=98192f4a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-98192f4a"

export default script